"use client";

import { useUserStore } from "@/store/store";
import { cn } from "@/lib/utils";
import { Button } from "./ui/button";
import { Dumbbell, PersonStanding } from "lucide-react";
import { BarbellsIcon, TrainerIcon } from "./icons";
import { useTranslations } from "next-intl";

export default function RoleToggle({ className }: { className?: string }) {
  const { role, setRole } = useUserStore();
  const t = useTranslations("early_access");

  return (
    <div
      className={cn(
        "flex items-center bg-black-bg border border-[#636363] rounded-full p-1 w-fit",
        className
      )}
    >
      <Button
        onClick={() => setRole("client")}
        className={cn(
          "px-6 py-2 h-fit rounded-full bg-transparent hover:bg-transparent text-sm font-medium transition-all duration-200",
          {
            "bg-gradient-to-t from-primary to-second-primary text-white shadow-sm":
              role === "client",
          }
        )}
      >
        <BarbellsIcon className=" fill-white" />
        {t("client")}
      </Button>
      <Button
        onClick={() => setRole("trainer")}
        className={cn(
          "px-6 py-2 h-fit rounded-full bg-transparent hover:bg-transparent text-sm font-medium transition-all duration-200",
          {
            "bg-gradient-to-t from-primary to-second-primary text-white shadow-sm":
              role === "trainer",
          }
        )}
      >
        <TrainerIcon
          className={cn(
            "fill-white last-of-type:[&_path]:fill-black last-of-type:[&_path]:stroke-black",
            {
              "last-of-type:[&_path]:fill-primary last-of-type:[&_path]:stroke-primary":
                role === "trainer",
            }
          )}
        />
        {t("trainer")}
      </Button>
    </div>
  );
}
